export default "__VITE_ASSET__C_mT9Rs___ 224w, __VITE_ASSET__msAFWzPW__ 448w";